module.exports = __webpack_public_path__ + "static/media/truck2.458e95c5.svg";